import { datadogLogs } from '@datadog/browser-logs'

const authLogger = datadogLogs.createLogger('authLogger', {
  level: DD_LOGS_LEVEL || 'error',
  handler: DD_LOGS_HANDLER || 'console',
  context: {
    domain: 'auth',
  },
})

export default authLogger
